/**
 * Full-screen loading skeleton with aria-busy. Used by route guards
 * during the initial session-check or while /v1/me is in flight.
 */
export function LoadingScreen({ label }: { label: string }) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className="flex min-h-screen items-center justify-center"
    >
      <div className="flex flex-col items-center gap-3 text-zinc-500 dark:text-zinc-400">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-300 border-t-brand-500 dark:border-zinc-700" />
        <span className="text-sm">{label}</span>
      </div>
    </div>
  );
}
